module.exports = __webpack_public_path__ + "img/20210906-1630913553907825.ee6861ab.png";